<script setup lang="ts">
import { RiQuestionFill } from '@remixicon/vue';
import { useSlots } from 'vue';

// #region Component Interface
const props = defineProps<{
    content?: string | null;
    inline?: boolean;
    iconClass?: any;
}>();
// #endregion

const slots = useSlots();
</script>

<template>
    <template v-if="slots.default || content">
        <template v-if="inline">
            <slot>
                {{ content }}
            </slot>
        </template>
        <Tooltip v-else>
            <RiQuestionFill :class="iconClass ?? 'icon-sm text-secondary'" />
            <template #popper>
                <slot>
                    <p v-html="content"></p>
                </slot>
            </template>
        </Tooltip>
    </template>
</template>

<style scoped></style>
